import ContentHeader from 'components/ContentHeader';

import { clsx } from 'clsx';
import i18n from 'i18n-react';
import { Link } from 'react-router-dom';

export interface FastTrackStatusBannerProps {
  answered: number;
  onAbandon: () => void;
}

export function FastTrackStatusBanner({ answered, onAbandon }: FastTrackStatusBannerProps) {
  return (
    <div className={clsx('trainingGrid', 'fast-track')}>
      <span className="subHeader">
        <ContentHeader
          header={i18n.translate('contentHeaders.fastTrack')}
          subtitle={i18n.translate('pageDescriptions.fastTrack')}
          line
        />
      </span>
      <div className="fast-track__actions">
        <Link to={`/main/fasttrack/chapter/0/${answered}`} className="fast-track__btn fast-track__btn--continue">
          {i18n.translate('trainingScreens.fastTrackContinue')}
        </Link>
        <button className="fast-track__btn fast-track__btn--abandon" onClick={onAbandon}>
          {i18n.translate('trainingScreens.fastTrackMoveToFull')}
        </button>
      </div>
    </div>
  );
}
